import { render, staticRenderFns } from "./CultureAboutJinqiaoContentOkayAudit.vue?vue&type=template&id=0e1265a3&scoped=true&"
import script from "./CultureAboutJinqiaoContentOkayAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAboutJinqiaoContentOkayAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1265a3",
  null
  
)

export default component.exports